(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.dashboard-bid', [
    'pp.widgets-templates',
    'ui.router',
    'pp.widgets.dashboard-bid-table',
    'pp.services.dashboard',
    'pp.services.investor',
    'pp.services.core'
]);

ngModule.component('ppDashboardBid', {
    templateUrl: 'widgets/_angular/dashboard-bid/dashboard-bid.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', '$stateParams', '$transitions', 'dashboardService', 'investorService', 'ppUtil', function ($scope, $stateParams, $transitions, dashboardService, investorService, ppUtil) {
        var vm = this;

        // -- initial state

        // -- util functions

        function init() {
            return dashboardService.getBids().then(function (data) {
                vm.data = data;
                vm.openSidebarSymbol = $stateParams.propertySymbol;
                vm.loadError = false;
            }, function () {
                vm.loadError = true;
            });
        }

        function updateBids(bids) {
            vm.data.bids = ppUtil.indexListBy(bids, 'symbol');
            init();
        }

        function updateOffers(offers) {
            vm.data.offers = ppUtil.indexListBy(offers, 'propertySymbol');
        }

        // -- api

        vm.onChange = function () {
            init();
        };

        // -- lifecycle

        vm.$onDestroy = function () {
            investorService.off('investor.holdings.bid.updated', updateBids);
            investorService.off('investor.holdings.listed.updated', updateOffers);
        };

        $transitions.onSuccess({}, function (transition) {
            vm.openSidebarSymbol = $stateParams.propertySymbol;
        });

        // -- main

        init().then(function () {
            vm.ready = true;

            investorService.on('investor.holdings.bid.updated', updateBids);
            investorService.on('investor.holdings.listed.updated', updateOffers);
        });

    }]
});
})(window, window.angular);